"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RichTextEditor = void 0;
var _react = require("react");
var _hooks = require("../../hooks");
var _urls = require("../../utilities/urls");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
var _RichTextEditor = _interopRequireDefault(require("./RichTextEditor.styles"));
var _RichTextEditor2 = require("./RichTextEditor.helpers");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
window.cet = window.cet || {};
window.cet.cc_data = window.cet.cc_data || {};
window.cet.cc_data.tinymce = window.cet.cc_data.tinymce || {
  indexId: 0,
  counter: 0
};
var useScriptsList = {
  scriptsList: [{
    src: "".concat(_urls.cdnUrl, "/libs/jquery/2.1.1/jquery-2.1.1.min.js"),
    checkIfAlreadyLoaded: function checkIfAlreadyLoaded() {
      return !!window.jQuery;
    },
    isWaitUntilLoaded: true
  }, {
    src: "".concat(_urls.cdnUrl, "/libs/tinymcePresets/2/tinymcePresets.bundle.min.js"),
    checkIfAlreadyLoaded: function checkIfAlreadyLoaded() {
      return !!(window.cet && window.cet.tinymcePresets && window.cet.tinymcePresets.presets);
    }
  }, {
    src: "".concat(_urls.cdnUrl, "/libs/tinymce.view.modules/1.0/tinymceViewModules.bundle.min.js"),
    checkIfAlreadyLoaded: function checkIfAlreadyLoaded() {
      return !!(window.cet && window.cet.uploadfileapi);
    }
  }, {
    src: "".concat(_urls.cdnUrl, "/libs/tinymce/4.2.8/tinymce.min.js"),
    checkIfAlreadyLoaded: function checkIfAlreadyLoaded() {
      return !!window.tinymce;
    }
  }]
};
var RichTextEditor = function RichTextEditor(props) {
  var _useDeviceData = (0, _hooks.useDeviceData)(),
    htmlFontSize = _useDeviceData.htmlFontSize;
  var _useContext = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext),
    language = _useContext.language,
    direction = _useContext.direction,
    basicFontSize = _useContext.basicFontSize,
    themeColors = _useContext.themeColors;
  var _props$placeholder = props.placeholder,
    placeholder = _props$placeholder === void 0 ? '' : _props$placeholder,
    _props$content = props.content,
    content = _props$content === void 0 ? '' : _props$content,
    _props$isReadOnly = props.isReadOnly,
    isReadOnly = _props$isReadOnly === void 0 ? false : _props$isReadOnly,
    _props$isWithAutoResi = props.isWithAutoResize,
    isWithAutoResize = _props$isWithAutoResi === void 0 ? false : _props$isWithAutoResi,
    _props$height = props.height,
    height = _props$height === void 0 ? '100%' : _props$height,
    onChanged = props.onChanged;
  var _useScripts = (0, _hooks.useScripts)(useScriptsList),
    isScriptsReady = _useScripts.isReady,
    error = _useScripts.error;
  var _useStylesUtils = (0, _hooks.useStylesUtils)(),
    getMeasurement = _useStylesUtils.getMeasurement;
  var styles = (0, _RichTextEditor.default)(props);
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    id = _useState2[0],
    setId = _useState2[1];
  var tinyContent = (0, _react.useRef)(content);
  var tinyEditor = (0, _react.useRef)(null);
  var onChangedRef = (0, _react.useRef)(function (value) {});
  var handleEditorInit = (0, _react.useCallback)(function (editor) {
    var iframe = editor.iframeElement;
    iframe.style.height = getMeasurement(height);
    if (height === '100%') {
      (0, _RichTextEditor2.setTinymceFullHeight)(iframe);
    }
    var onChangedHandler = function onChangedHandler() {
      if (editor) {
        var _content = editor.getContent({
          format: 'raw'
        });
        if (_content !== tinyContent.current) {
          tinyContent.current = _content;
          if (onChangedRef) onChangedRef.current(_content);
        }
      }
    };
    editor.on('input blur cut focusout paste ExecCommand', onChangedHandler);
  }, [getMeasurement, height]);
  (0, _react.useEffect)(function () {
    window.cet.cc_data.tinymce.counter++;
    window.cet.cc_data.tinymce.indexId++;
    var indexId = window.cet.cc_data.tinymce.indexId;
    setId("cc_tinymce_indexId__".concat(indexId));
    return function () {
      window.cet.cc_data.tinymce.counter--;
      if (tinyEditor.current) {
        tinyEditor.current.remove();
      }
      tinyEditor.current = null;
    };
  }, []);
  (0, _react.useEffect)(function () {
    onChangedRef.current = onChanged || function (value) {};
  }, [onChanged]);
  (0, _react.useEffect)(function () {
    if (isScriptsReady && !error && id) {
      if (window.tinymce.get(id) !== null) {
        window.tinymce.get(id).remove();
      }
      tinyEditor.current = null;
      var tinymceOptions = window.cet.tinymcePresets.getTinymcePreset('default', '#' + id, language, {
        directionality: direction
      });
      tinymceOptions.setup = function (editor) {
        tinyEditor.current = editor;
        editor.on('BeforeSetContent', _RichTextEditor2.cleanContent);
        editor.on('init', function () {
          handleEditorInit(editor);
        });
      };
      tinymceOptions.readonly = isReadOnly;
      if (!isWithAutoResize || height === '100%') {
        (0, _RichTextEditor2.removeAutoResize)(tinymceOptions);
      }
      tinymceOptions.content_style = (tinymceOptions.content_style || '') + " html {font-size: ".concat(htmlFontSize, "} body.tiny-body {color: ").concat(themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.text, "; font-size: ").concat(basicFontSize, "; font-family: sans-serif; line-height: 1.5;}");
      window.tinymce.init(tinymceOptions);
    }
  }, [basicFontSize, direction, error, handleEditorInit, height, htmlFontSize, id, isReadOnly, isScriptsReady, isWithAutoResize, language, themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.text]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: styles['cc-RichTextEditor'],
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("textarea", {
      "data-testid": "ccRichTextEditorContent",
      id: id,
      placeholder: placeholder,
      defaultValue: tinyContent.current
    })
  });
};
exports.RichTextEditor = RichTextEditor;